module.exports = __webpack_public_path__ + "static/MAMPARADIVISORIA-96f3de5129c5c2da0291aafc55e0401a.webp";